import { setNonce } from "get-nonce";

/**
 * Per-request CSP nonce for the <style> elements the UI libraries inject
 * (#1022). The policy has no 'unsafe-inline', so every inline stylesheet needs
 * a nonce or a pinned hash:
 *
 * - react-style-singleton (Radix Dialog's scroll lock) writes the measured
 *   scrollbar width into its CSS, so the content, and therefore any hash,
 *   differs per browser and OS. It reads the nonce from get-nonce.
 * - Radix ScrollArea and Select viewports take it as a `nonce` prop.
 * - sonner has no nonce option; nginx-main.conf.template pins its hash instead.
 *
 * nginx replaces the placeholder in index.html with `$request_id`, the same
 * value it puts in the header's 'nonce-…' source. `npm run dev` and unit tests
 * serve the placeholder unreplaced and send no CSP, so it is ignored there.
 */
export const CSP_NONCE_PLACEHOLDER = "__CSP_NONCE__";

export function readCspNonce(doc: Document): string | undefined {
  const meta = doc.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]');
  // Under a header-delivered CSP, browsers blank the nonce *attribute* to keep
  // it out of reach of CSS selectors; the IDL property keeps the value.
  const value = meta?.nonce || meta?.getAttribute("nonce") || "";
  return value && value !== CSP_NONCE_PLACEHOLDER ? value : undefined;
}

export const cspNonce = typeof document === "undefined" ? undefined : readCspNonce(document);

if (cspNonce) {
  setNonce(cspNonce);
}
